import React, { useState } from "react";
import { filterLanded } from "../lib/columnFilter";
import { jobsByStatus } from "../lib/selectors";
import { useMcOps } from "../lib/McOpsContext";
import { ColumnFilter, KanbanColumn, StatCard } from "../components/Common";
import { BoardTitleRow } from "../components/JobSearch";

/**
 * Post Move board, three columns (Miles, 2026-10-18, Asana 1219375712610643):
 * Clients to Call, Clients Confirmed via Automation, Post-Move Closed. The
 * "MC to Decide" column is parked until the automation is finalised, so an
 * in-between job (`postMoveRoute === "between"`) is a call. Marking it for the
 * automated check-in sends nothing yet (Asana 1219524311157587), so it stays
 * a call. A closed job leaves its column for Post-Move Closed.
 */
const isClosed = (j) => !!j.postMoveClosed;

export const PostMovePage = () => {
  const { state } = useMcOps();
  const [filters, setFilters] = useState({ call: "all", auto: "all", closed: "all" });
  const filterFor = (column) => (
    <ColumnFilter
      value={filters[column]}
      onChange={(key) => setFilters((prev) => ({ ...prev, [column]: key }))}
    />
  );
  const callQueue = jobsByStatus(state, "post-move-vip");
  const vip = filterLanded(callQueue.filter((j) => !isClosed(j)), filters.call);
  const auto = filterLanded(jobsByStatus(state, "post-move-auto").filter((j) => !isClosed(j)), filters.auto);
  const closed = filterLanded(
    [...callQueue, ...jobsByStatus(state, "post-move-auto")].filter(isClosed),
    filters.closed,
  );

  return (
    <div className="page active">
      <BoardTitleRow title="Post Move" />

      <div className="landing-grid cols-3">
        <StatCard icon="phone" color="red" num={vip.length} label="Clients to Call Post-Move" />
        <StatCard icon="check" color="green" num={auto.length} label="Confirmed via Automation" />
        <StatCard icon="clipboard" color="blue" num={closed.length} label="Post-Move Closed" />
      </div>

      <div className="kanban cols-3">
        <KanbanColumn
          title="Clients to Call Post-Move"
          jobs={vip}
          color="var(--danger)"
          tab="s5"
          toolbar={filterFor("call")}
        />
        <KanbanColumn
          title="Clients Confirmed via Automation"
          jobs={auto}
          color="var(--success)"
          tab="s5"
          toolbar={filterFor("auto")}
        />
        <KanbanColumn
          title="Post-Move Closed"
          jobs={closed}
          color="var(--primary)"
          tab="s5"
          toolbar={filterFor("closed")}
          emptyLabel="No post-move jobs closed yet"
        />
      </div>
    </div>
  );
};
